import { IRequestsData } from 'API';
import { IPersonalDetailsReqAttach } from 'Interfaces/updatePersonalDetails';
import { createContext, FC, useState } from 'react';

interface IRequestsContext {
  requestsData: IRequestsData;
  setRequestsData: (
    callback: (requestsData: IRequestsData) => IRequestsData,
  ) => void;
  resetRequestsData: () => void;
  reqAttachSchema: IPersonalDetailsReqAttach;
  setReqAttachSchema: (
    callback: (
      reqAttachSchema: IPersonalDetailsReqAttach,
    ) => IPersonalDetailsReqAttach,
  ) => void;
}

const initialValues = {
  fieldAttachmentsData: [
    {
      fieldId: '',
      attachments: {},
    },
  ],
  note: '',
  phoneNumber: '',
  phonePrefix: '',
  type: 0,
  requestDataJson: {},
};

export const RequestsContext = createContext<IRequestsContext>({
  requestsData: { ...initialValues },
  setRequestsData: () => {},
  resetRequestsData: () => {},
  reqAttachSchema: {},
  setReqAttachSchema: () => {},
});

export const RequestsProvider: FC<React.PropsWithChildren> = (props) => {
  const [requestsData, setRequestsData] = useState<IRequestsData>({
    ...initialValues,
  });
  const [reqAttachSchema, setReqAttachSchema] =
    useState<IPersonalDetailsReqAttach>({});

  const resetRequestsData = () => {
    setRequestsData(() => ({ ...initialValues }));
  };

  return (
    <RequestsContext.Provider
      value={{
        requestsData,
        setRequestsData,
        resetRequestsData,
        reqAttachSchema,
        setReqAttachSchema,
      }}
    >
      {props.children}
    </RequestsContext.Provider>
  );
};
